import { render, staticRenderFns } from "./bankReadRule.vue?vue&type=template&id=724487ca&scoped=true"
import script from "./bankReadRule.vue?vue&type=script&lang=js"
export * from "./bankReadRule.vue?vue&type=script&lang=js"
import style0 from "./bankReadRule.vue?vue&type=style&index=0&id=724487ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724487ca",
  null
  
)

export default component.exports